import type { ReactElement } from "react";
import { Link } from "react-router";

import { navLinkClassName } from "@/lib/utils";

export interface ViewTab {
  readonly label: string;
  /** The list's address with its view, e.g. `/sponsoren?ansicht=kunden`. */
  readonly to: string;
}

/** The views of a list under its heading (E8): links, so a reload keeps the tab. */
export function ViewTabs({
  label,
  tabs,
  current,
}: {
  /** The name of the navigation for screen readers. */
  readonly label: string;
  readonly tabs: readonly ViewTab[];
  /** The label of the tab shown. */
  readonly current: string;
}): ReactElement {
  return (
    <nav aria-label={label} className="mb-6">
      <ul className="inline-flex gap-1 rounded-md bg-muted p-1">
        {tabs.map((tab) => (
          <li key={tab.label}>
            <Link
              to={tab.to}
              aria-current={tab.label === current ? "page" : undefined}
              className={navLinkClassName({ isActive: tab.label === current })}
            >
              {tab.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}
